import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AsyncStatus } from "../../models/async-status";
import { UnscheduledDistributionElection } from "../../models/distributions/unscheduled-distribution-election";
import { getAccountLevelElections } from "../../services/distributions";

export const fetchAccountLevelElections = createAsyncThunk(
  "fetch-account-elections",
  async (
    { planId, empId, role }: { planId: number; empId: number; role: string },
    thunkApi
  ) => {
    return getAccountLevelElections({ planId, empId, role });
  }
);

type State = {
  accountLevelElections: UnscheduledDistributionElection[];
  status: AsyncStatus;
};

const initialState: State = {
  accountLevelElections: [],
  status: AsyncStatus.not_fetched,
};

const accountLevelElectionsSlice = createSlice({
  name: "accountLevelElections",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAccountLevelElections.pending, (state, action) => {
      return { ...state, status: AsyncStatus.loading };
    });
    builder.addCase(
      fetchAccountLevelElections.fulfilled,
      (
        state,
        action: { payload: UnscheduledDistributionElection[]; type: string }
      ) => {
        const accountLevelElections = action.payload;

        return {
          ...state,
          accountLevelElections,
          status: AsyncStatus.done,
        };
      }
    );
    builder.addCase(fetchAccountLevelElections.rejected, (state, action) => {
      return { ...state, status: AsyncStatus.error };
    });
    builder.addDefaultCase((state, action) => state);
  },
});

export default accountLevelElectionsSlice.reducer;
